// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__va_H0","title":"Images90_title__3HZrW","images":"Images90_images__2mUec"};